export default {
    renderFileAsDataURL(file) {
		return new Promise((resolve, reject) => {
			if (typeof FileReader === 'function') {
				const reader = new FileReader();
				reader.onload = (event) => {
					resolve(event.target.result);
				};
				reader.readAsDataURL(file);
			} else {
				reject('FileReader is not function');
			}
		})
	},
}